import React, { useEffect, useState } from "react";
import "./index.css";
import TickmarkImage from "../Tickmark.png";
import ErrorImage from "../Error.png";
import useHttp from "../use-http/use-http";
import loadingGif from "../loading-gif.gif";

let flag = false;
let croppedFile;
const Modal = (props) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyDHdkmGjsfNqasFs6m9CooShFZsqWHcdUs&callback=myInitMap&libraries=places&v=weekly";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  const [isSubmitClicked, setIsSubmitClicked] = useState(false);
  const [apiResponse, setApiResponse] = useState("");
  const [errorDetails, setErrorDetails] = useState("");

  const authenticateUser = (data) => {
    console.log('📥 API Response received:', data);
    console.log('📥 Response type:', typeof data);
    
    // Handle different response formats
    if (typeof data === 'string') {
      // Network or parsing error
      console.error('❌ Network or parsing error:', data);
      setErrorDetails(data);
      setApiResponse("Error");
      return;
    }
    
    // Handle numeric response (some APIs return just a number for success, like 3)
    if (typeof data === 'number') {
      console.log('✅ Numeric response received:', data, '- treating as success');
      setApiResponse("Success");
      setErrorDetails("");
      return;
    }
    
    if (!data) {
      console.error('❌ Empty response received');
      setErrorDetails("No response from server");
      setApiResponse("Error");
      return;
    }
    
    // Check for success status (Status 000 indicates success in this API)
    if (data.Status === "000" || (data.Message && data.Message.toLowerCase() === "success")) {
      console.log('✅ Registration successful');
      setApiResponse("Success");
      setErrorDetails("");
    } else {
      // API returned an error status
      console.error('❌ API Error Response:', {
        status: data.Status,
        message: data.Message,
        dbErrorMessage: data.DBErrorMessage,
        dbErrorMessageID: data.DBErrorMessageID,
        dbErrorSeverity: data.DBErrorSeverity,
        dbErrorState: data.DBErrorState,
        dbErrorLine: data.DBErrorLine,
        dbErrorProcedure: data.DBErrorProcedure,
        error: data.Error,
        fullResponse: data
      });
      
      // Build user-friendly error message with maximum detail
      let errorMsg = data.DBErrorMessage || data.Message || data.Error || "Registration failed";
      
      // Add more context if available
      if (data.DBErrorMessageID) {
        errorMsg += ` (Error ID: ${data.DBErrorMessageID})`;
      }
      
      // Add database error procedure if available (indicates which stored procedure failed)
      if (data.DBErrorProcedure) {
        errorMsg += ` [Procedure: ${data.DBErrorProcedure}]`;
      }
      
      setErrorDetails(errorMsg);
      setApiResponse("Error");
    }
  };

  // Class mapping to convert string to numeric code (matching bulk upload logic)
  // Preschool: Playgroup=13, PP1=14, PP2=0, then Grade 1=1, etc.
  const getClassCode = (classString) => {
    const classMapping = {
      // Preschool levels
      'Playgroup': 13, 'PP1': 14, 'PP2': 0,
      // Primary and secondary grades
      'Grade 1': 1, 'Grade 2': 2, 'Grade 3': 3, 'Grade 4': 4, 'Grade 5': 5,
      'Grade 6': 6, 'Grade 7': 7, 'Grade 8': 8, 'Grade 9': 9, 'Grade 10': 10,
      'Grade 11': 11, 'Grade 12': 12,
      'Form 1': 9, 'Form 2': 10, 'Form 3': 11, 'Form 4': 12, // Secondary school mapping
      'Class 1': 1, 'Class 2': 2, 'Class 3': 3, 'Class 4': 4, 'Class 5': 5,
      'Class 6': 6, 'Class 7': 7, 'Class 8': 8, 'Class 9': 9, 'Class 10': 10
    };
    const code = classMapping[classString] || classString;
    // Ensure we return a number for the classstandards field
    return typeof code === 'string' ? parseInt(code, 10) : code;
  };

  const { isLoading, sendRequest } = useHttp();

  useEffect(() => {
    // debugger;
    if (isSubmitClicked) {
      // Validate corporate information before sending (matching bulk upload validation)
      if (!props.corpId || !props.corpName) {
        console.error('❌ Corporate ID and Corporate Name are required:', {
          corpId: props.corpId,
          corpName: props.corpName
        });
        alert('Corporate ID and Corporate Name are required. Please check the URL parameters.');
        return;
      }

      // Log the data being sent for debugging
      const requestPayload = {
        corporateID: props.corpId,
        corporateName: props.corpName,
        staffFirstName: props.studentfirstname,
        staffLastName: props.studentlastname,
        classstandards: props.type === "Student" ? getClassCode(props.studentclass) : "",
        staffImage: props.studentPhoto,
        parentFirstName:
          props.type === "Student" ? props.parentfirstname : "",
        parentLastName:
          props.type === "Student" ? props.parentlastname : "",
        parentsMobileNumber:
          props.type === "Student"
            ? props.countryCode + props.parentmobilenumber
            : "",
        parentEmailAddress:
          props.type === "Student" ? props.parentemailaddress : "",
        address: props.address,
        // Format coordinates as "lat,lng" with proper number conversion
        pickupLL: Number(props.pickupLatLng.lat) + "," + Number(props.pickupLatLng.lng),
        dropLL: Number(props.dropLatLng.lat) + "," + Number(props.dropLatLng.lng),
        staffMobileNumber:
            props.edit
            ? props.qrcode : ( props.type === "Student"
                ? ""
                : props.countryCode + props.studentclass)
              ,
        area: props.area,
        city: props.city,
        emailID: "",
        pickupStop: props.pickupStop,
        dropStop: props.dropStop,
        corporateType: props.type === "Student" ? "school" : "corporate",
        // isAdd: props.edit ? 0 : 1,
        qrcode: props.qrcode,
      };

      // Validate required fields before sending
      const requiredFields = [
        { name: 'corporateID', value: props.corpId, label: 'Corporate ID' },
        { name: 'corporateName', value: props.corpName, label: 'Corporate Name' },
        { name: 'staffFirstName', value: props.studentfirstname, label: 'Student First Name' },
        { name: 'staffLastName', value: props.studentlastname, label: 'Student Last Name' },
        { name: 'address', value: props.address, label: 'Address' },
        { name: 'city', value: props.city, label: 'City' },
        { name: 'area', value: props.area, label: 'Area' },
       
      ];

      if (props.type === "Student") {
        requiredFields.push(
          { name: 'classstandards', value: requestPayload.classstandards, label: 'Class/Standard' },
          { name: 'parentFirstName', value: props.parentfirstname, label: 'Parent First Name' },
          { name: 'parentLastName', value: props.parentlastname, label: 'Parent Last Name' },
          { name: 'parentsMobileNumber', value: props.parentmobilenumber, label: 'Parent Mobile Number' },
           { name: 'pickupStop', value: props.pickupStop, label: 'Pickup Stop' },
        { name: 'dropStop', value: props.dropStop, label: 'Drop Stop' },

        );
      }

      // Check for missing required fields
      const missingFields = requiredFields.filter(field => 
        field.value === null || field.value === undefined || field.value === '' || 
        (typeof field.value === 'string' && !field.value.trim())
      );

      if (missingFields.length > 0) {
        const missingNames = missingFields.map(f => f.label).join(', ');
        console.error('❌ Missing required fields:', missingNames);
        setErrorDetails(`Missing required fields: ${missingNames}`);
        setApiResponse("Error");
        return;
      }

      // Validate coordinate format
      if (!props.pickupLatLng || props.pickupLatLng.lat === undefined || props.pickupLatLng.lng === undefined) {
        console.error('❌ Invalid pickup coordinates');
        setErrorDetails("Pickup location coordinates are missing or invalid");
        setApiResponse("Error");
        return;
      }
      if (!props.dropLatLng || props.dropLatLng.lat === undefined || props.dropLatLng.lng === undefined) {
        console.error('❌ Invalid drop coordinates');
        setErrorDetails("Drop location coordinates are missing or invalid");
        setApiResponse("Error");
        return;
      }

      console.log('🔍 Individual registration payload:', JSON.stringify(requestPayload, null, 2));
      
      // Additional detailed logging for debugging
      console.log('📊 Field-by-field validation:', {
        corporateID: { value: requestPayload.corporateID, type: typeof requestPayload.corporateID },
        corporateName: { value: requestPayload.corporateName, type: typeof requestPayload.corporateName },
        staffFirstName: { value: requestPayload.staffFirstName, type: typeof requestPayload.staffFirstName },
        staffLastName: { value: requestPayload.staffLastName, type: typeof requestPayload.staffLastName },
        classstandards: { value: requestPayload.classstandards, type: typeof requestPayload.classstandards },
        staffImage: { value: requestPayload.staffImage, type: typeof requestPayload.staffImage },
        parentFirstName: { value: requestPayload.parentFirstName, type: typeof requestPayload.parentFirstName },
        parentLastName: { value: requestPayload.parentLastName, type: typeof requestPayload.parentLastName },
        parentsMobileNumber: { value: requestPayload.parentsMobileNumber, type: typeof requestPayload.parentsMobileNumber },
        parentEmailAddress: { value: requestPayload.parentEmailAddress, type: typeof requestPayload.parentEmailAddress },
        address: { value: requestPayload.address, type: typeof requestPayload.address },
        pickupLL: { value: requestPayload.pickupLL, type: typeof requestPayload.pickupLL },
        dropLL: { value: requestPayload.dropLL, type: typeof requestPayload.dropLL },
        staffMobileNumber: { value: requestPayload.staffMobileNumber, type: typeof requestPayload.staffMobileNumber },
        area: { value: requestPayload.area, type: typeof requestPayload.area },
        city: { value: requestPayload.city, type: typeof requestPayload.city },
        emailID: { value: requestPayload.emailID, type: typeof requestPayload.emailID },
        pickupStop: { value: requestPayload.pickupStop, type: typeof requestPayload.pickupStop },
        dropStop: { value: requestPayload.dropStop, type: typeof requestPayload.dropStop },
        corporateType: { value: requestPayload.corporateType, type: typeof requestPayload.corporateType },
      });
      
      sendRequest(
        {
          url: "/api/v1/Staff/AddEditStaff",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: requestPayload,
        },
        authenticateUser
      );
    }
  }, [sendRequest, isSubmitClicked]);

  const DataSubmitHandler = () => {
    let element = document.getElementsByClassName("header")[0];
    element.scrollIntoView({ behavior: "smooth", block: "end" });
    flag = true;
    setIsSubmitClicked(true);
  };
  const closeDataSavedClickHandler = () => {
    setTimeout(() => {
      window.location.reload();
    });
  };

  function myInitMap() {
    var map = new window.google.maps.Map(document.getElementById("map-modal"), {
      // center: props.pickupLatLng,
      center: props.pickupLatLng,
      zoom: 12,
      disableDefaultUI: true,
      fullscreenControl: true,
      zoomControl: true,
    });

    const infoWindow = new window.google.maps.InfoWindow();
    // let marker = new window.google.maps.Marker({
    //   position: props.pickupLatLng,
    //   map,
    //   myTitle: `Pickup Stop: ${props.pickupStop.split(",")[0]}`,
    //   draggable: false,
    // });
    let position = [props.pickupLatLng, props.dropLatLng];
    let title = [
      `Pickup Stop: ${props.pickupStop.split(",")[0]}`,
      `Drop Stop: ${props.dropStop.split(",")[0]}`,
    ];
    for (let i = 0; i < 2; i++) {
      const marker = new window.google.maps.Marker({
        position: position[i],
        map,
        myTitle: title[i],
        draggable: false,
      });
      marker.addListener("mouseover", () => {
        console.log(marker);
        infoWindow.close();
        infoWindow.setContent(marker.myTitle);
        infoWindow.open(marker.getMap(), marker);
      });
    }
  }
  window.myInitMap = myInitMap;

  return (
    <React.Fragment>
      {!isSubmitClicked && (
        <div className="modalBackground">
          <div className="modalContainer">
            <div className="header">
              <div className="header-text">Please Verify Your Details</div>
              <div
                className="close"
                onClick={() => props.closeCLickHandler(false)}
              >
                &times;
              </div>
            </div>
            <div className="main-container">
              <div className="sub-container">
                <div>
                  <div className="student-school">
                    <label>
                      {props.type === "Student"
                        ? "School/Institute Name"
                        : "Corporate Name"}{" "}
                    </label>
                    <input
                      type="text"
                      value={props.schoolname}
                      readOnly
                    ></input>
                  </div>
                  <h4>
                    {props.type === "Student"
                      ? "Student Details"
                      : "Staff Details"}
                  </h4>
                  <div className="student-details">
                    <div>
                      <div>
                        <label>
                          {(props.type === "Student" ? "Student" : "Staff") +
                            " passport size photo"}
                        </label>
                        <div className="student-photo">
                          <img src={props.myOriginalFile} alt="photo"></img>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div>
                        <label>First Name</label>
                        <input
                          type="text"
                          value={props.studentfirstname}
                          readOnly
                        ></input>
                      </div>
                      <div>
                        <label>last name</label>
                        <input
                          type="text"
                          value={props.studentlastname}
                          readOnly
                        ></input>
                      </div>
                      <div>
                        <label>
                          {props.type === "Student"
                            ? "class standards"
                            : "Department"}
                        </label>
                        <input
                          type="text"
                          value={props.studentclass}

                          // selectedoptions={props.studentclass}
                          readOnly
                        ></input>
                      </div>
                    </div>
                  </div>
                  {props.type === "Student" && (
                    <React.Fragment>
                      <h4>Parent Details</h4>
                      <div className="parent-details">
                        <div>
                          <div>
                            <label>first name</label>
                            <input
                              type="text"
                              value={props.parentfirstname}
                              readOnly
                            ></input>
                          </div>
                          <div>
                            <label>Mobile number</label>
                            <input
                              type="text"
                              value={props.parentmobilenumber}
                              readOnly
                            ></input>
                          </div>
                        </div>
                        <div>
                          <div>
                            <label>last name </label>
                            <input
                              type="text"
                              value={props.parentlastname}
                              readOnly
                            ></input>
                          </div>
                          <div>
                            <label>Email Address</label>
                            <input
                              type="email"
                              value={props.parentemailaddress}
                              readOnly
                            ></input>
                          </div>
                        </div>
                      </div>
                    </React.Fragment>
                  )}
                  <h4>Address Details</h4>
                  <div className="parent-details">
                    <div>
                      <input
                        className="address"
                        type="text"
                        value={props.address}
                        readOnly
                      ></input>
                    </div>
                  </div>
                </div>
                <div className="review-address-details">
                  <div>
                    <label>
                      {(props.type === "Student" ? "Bus" : "Bus/ Cab") +
                        " Pickup Stop"}
                    </label>
                    {/* <input type="text" value={props.address} readOnly></input> */}
                    <div className="mystudent-address">{props.pickupStop}</div>
                  </div>
                  <div>
                    <label>
                      {(props.type === "Student" ? "Bus" : "Bus/ Cab") +
                        " Drop Stop"}
                    </label>
                    {/* <input type="text" value={props.address} readOnly></input> */}
                    <div className="mystudent-address">{props.dropStop}</div>
                  </div>
                  <br />
                  {/* <div> */}
                  <div id="map-modal"></div>
                  {/* </div> */}
                </div>
              </div>
            </div>
            <div className="footer">
              <div className="text">
                <span>Need to Edit some details?</span>
                <button
                  onClick={() => props.closeCLickHandler(false)}
                  className="back-button"
                >
                  Go Back
                </button>
                <button onClick={DataSubmitHandler} className="submit-button">
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {isLoading && (
        <img
          src={loadingGif}
          style={{
            position: "absolute",
            top: "40%",
            left: "45%",
            height: "80px",
          }}
        />
      )}
      {apiResponse === "Success" && (
        <div className="container-success-msg">
          <div className="success-sub-container">
            <div className="success-msg">
              <img src={TickmarkImage} />
              <p className="data-save">Your data is saved successfully</p>
            </div>
            <hr />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "10px",
              }}
            >
              <button onClick={closeDataSavedClickHandler}>OK</button>
            </div>
          </div>
        </div>
      )}
      {apiResponse === "Error" && (
        <div className="container-success-msg">
          <div className="success-sub-container">
            <div className="success-msg">
              <img src={ErrorImage} />
              <p className="data-save">Registration Failed</p>
              {errorDetails && (
                <div style={{
                  fontSize: '14px',
                  color: '#d32f2f',
                  marginTop: '10px',
                  padding: '10px',
                  backgroundColor: '#ffebee',
                  borderRadius: '4px',
                  maxHeight: '150px',
                  overflowY: 'auto',
                  wordWrap: 'break-word'
                }}>
                  <strong>Error Details:</strong>
                  <p style={{ marginTop: '5px', marginBottom: 0 }}>{errorDetails}</p>
                </div>
              )}
            </div>
            <hr />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "10px",
              }}
            >
              <button onClick={closeDataSavedClickHandler} className="error">
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default Modal;
